import { ReactNode } from 'react'

function App ({ children }: { children: ReactNode }) {
  return (
    <div className="relative w-full min-h-screen">
      {children}
    </div>
  )
}

export default App
